<template>
  <div class="ov2024-list__result">
    <div v-if="selectedTelepules" @click="navigateUp()" class="ov2024-list__result__btn">
      <i class="mdi mdi-chevron-left"></i>
      <span v-if="isTelepules">{{ selectedTelepules.megyeNev }}{{ selectedTelepules.megyeNev !== 'Budapest' ? ' vármegye' : '' }}</span>
      <span v-if="isFovaros || isMegye">Országos nézet</span>
    </div>
    <span class="ov2024-list__title">
      <span>{{ getTelepulesNev }}</span>
      <span v-if="szavazokor" class="ov2024-list__subtitle">
        <span>{{ szavazokor.eredetiCim }}</span>
<!--        <span> - </span>-->
<!--        <span>{{ szavazokor.szavazokorok.join(', ') }}</span>-->
<!--        <span>. szavazókör{{ szavazokor.szavazokorok.length > 1 ? 'ök' : '' }}</span>-->
      </span>
    </span>
    <!-- reszvetel -->
    <div v-if="selectedLayer === 'reszvetel'" class="ov2024-list__result__container">
      <ov-participation-bar :selectedTimestamp="selectedTimestamp" :szazalekok="data?.properties?.reszvetelSzazalekok || null" />
    </div>
    <!-- feldolg -->
    <div v-if="selectedLayer === 'eredmenyek' && selectedTelepules && selectedTelepules.polgarmesterFeldolgozottsag" class="ov2024-list__result__container">
      <span class="dashboard-24__progress">
        <span class="ov2024-list__subtitle">
          Feldolgozottság:
        </span>
              <span class="dashboard-24__progress__line__bg">

                  <span
                      class="dashboard-24__progress__data"
                      :class="'dashboard-24__progress__data__color__2024o'"
                      :style="{ width: (selectedTelepules.polgarmesterFeldolgozottsag) + '%'}"
                  >
                      {{ selectedTelepules.polgarmesterFeldolgozottsag }}%
                  </span>
              </span>
          </span>
    </div>
    <!-- telepules/fovaros -->
    <div v-if="isTelepules || isFovaros" class="ov2024-list__result__container">
      <accordion :open="true" class="accordion">
        <template #title>
          <span class="ov2024-list__subtitle">
            <span v-if="isFovaros">
              Jelenlegi főpolgármester
            </span>
            <span v-else>
              2019-es győztes
            </span>
          </span>
        </template>
        <template #content>
          <span :class="{'ov2024-list__card--actual' : jelenlegiPolgarmester}" class="ov2024-list__card">
            <span class="ov2024-list__card__img" :style="jelenlegiPolgarmester.fenykep && !jelenlegiPolgarmester.fenykep.endsWith('default.jpg') ? { 'background-image': 'url(' + jelenlegiPolgarmester.fenykep + ')'} : ''" />
            <span class="ov2024-list__card__title">
              <span>{{ jelenlegiPolgarmester.nev }}</span>
              <span class="ov2024-list__card__party">
                <span
                    class="ov2024-list__card__party__color"
                    :style="{'background': getPartyColor(jelenlegiPolgarmester.jeloloCsoport.nev) }"
                />
                <span class="ov2024-list__card__party__item">{{ jelenlegiPolgarmester.jeloloCsoport.nev }}</span>
              </span>
              <span v-if="selectedLayer === 'eredmenyek'" class="ov2024-list__card__previous_result">
                <span>2019-es eredmény:</span>
                <span>{{ jelenlegiPolgarmester.szazalek }}% ({{ jelenlegiPolgarmester.szavazat }} szavazat)</span>
              </span>
            </span>
          </span>
        </template>
      </accordion>
      <accordion v-if="!szavazokor" :open="true" class="accordion">
        <template #title>
          <span class="ov2024-list__subtitle">
            <template v-if="isFovaros">
              A főpolgármester-választás
            </template>
            <template v-else>
              A polgármester-választás
            </template>
            <template v-if="selectedLayer === 'jeloltek'">
              jelöltjei
            </template>
            <template v-if="selectedLayer === 'eredmenyek'">
              eredményei
            </template>
          </span>
        </template>
        <template #content>
          <span v-for="jelolt in polgarmesterJeloltek" :key="jelolt.ejid" class="ov2024-list__card">
            <span class="ov2024-list__card__img" :style="!jelolt.fenykep.endsWith('default.jpg') ? { 'background-image': 'url(' + jelolt.fenykep + ')'} : ''" />
            <span class="ov2024-list__card__title">
              <span>{{ jelolt.nev }}</span>
              <span v-if="jelolt.jeloloCsoport" class="ov2024-list__card__party">
                <span
                    class="ov2024-list__card__party__color"
                    :style="{'background': getPartyColor(jelolt.jeloloCsoport) }"
                />
                <span class="ov2024-list__card__party__item">
                  <span v-if="jelolt.jeloloCsoport.tagok.length">
                    <span v-for="tag in jelolt.jeloloCsoport.tagok">{{ tag.nev }}</span>
                  </span>
                  <template v-else>{{ jelolt.jeloloCsoport.nev }}</template>
                  <span v-if="selectedLayer === 'eredmenyek'" class="ov2024-list__card__result">
                    <span class="dashboard-24__progress">
                        <span class="dashboard-24__progress__line__bg">
                            <span
                                class="dashboard-24__progress__data"
                                :style="{ 'background': getPartyColor(jelolt.jeloloCsoport), width: jelolt.szazalek + '%' }"
                            >
                                {{ jelolt.szazalek }}%
                            </span>
                        </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        </template>
      </accordion>
      <!-- szavazokor -->
      <template v-if="selectedLayer === 'eredmenyek' && szavazokorData && szavazokorData.data">
        <accordion v-for="(_szavazokor, _key) in szavazokorData.data" :key="_key" :open="false" class="accordion">
          <template #title>
            <span class="ov2024-list__subtitle">
              {{ _szavazokor.sorszam }}. szavazókör eredményei
            </span>
          </template>
          <template #content>
            <span v-for="jelolt in _szavazokor.polgarmesterJeloltek" :key="_key + jelolt.ejid" class="ov2024-list__card">
              <span class="ov2024-list__card__img" :style="!jelolt.fenykep.endsWith('default.jpg') ? { 'background-image': 'url(' + jelolt.fenykep + ')'} : ''" />
              <span class="ov2024-list__card__title">
                <span>{{ jelolt.nev }}</span>
                <span v-if="jelolt.jeloloCsoport" class="ov2024-list__card__party">
                  <span
                      class="ov2024-list__card__party__color"
                      :style="{'background': getPartyColor(jelolt.jeloloCsoport) }"
                  />
                  <span class="ov2024-list__card__party__item">
                    <span v-if="jelolt.jeloloCsoport.tagok.length">
                      <span v-for="tag in jelolt.jeloloCsoport.tagok">{{ tag.nev }}</span>
                    </span>
                    <template v-else>{{ jelolt.jeloloCsoport.nev }}</template>
                    <span v-if="selectedLayer === 'eredmenyek'" class="ov2024-list__card__result">
                      <span class="dashboard-24__progress">
                          <span class="dashboard-24__progress__line">
                              <span
                                  class="dashboard-24__progress__data"
                                  :style="{ 'background': getPartyColor(jelolt.jeloloCsoport), width: jelolt.szavazokorSzazalek + '%' }"
                              >
                                  {{ jelolt.szavazokorSzazalek }}%
                              </span>
                          </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </template>
        </accordion>
      </template>
      <template v-if="selectedLayer === 'reszvetel' && szavazokorData && szavazokorData.data">
        <div v-for="(_szavazokor, _key) in szavazokorData.data" :key="_key" class="dashboard-24__progress">
          <div class="dashboard-24__progress__line dashboard-24__progress__line">
            {{ _szavazokor.sorszam }}. szavazókör részvétel
            <div
                class="dashboard-24__progress__data"
                :class="'dashboard-24__progress__data__color__2024o'"
                :style="{ width: (_szavazokor._reszvetel.szazalek) + '%'}"
            >
              {{ _szavazokor._reszvetel.szazalek }}%
            </div>
          </div>
        </div>
      </template>

<!--      <ov-part-bar-->
<!--          v-if="selectedLayer === 'eredmenyek' && evkTelepulesek && evkTelepulesek.length > 0"-->
<!--          title="Az önkormányzat összetétele"-->
<!--          :data="evkTelepulesek"-->
<!--      />-->

      <!--      <ov-part-bar-->
<!--          v-if="selectedLayer === 'eredmenyek' && evkTelepulesek && evkTelepulesek.length > 0"-->
<!--          title="Választókerületi listás eredmény"-->
<!--          :data="evkTelepulesek"-->
<!--      />-->
<!--      <ov-part-bar-->
<!--          v-if="selectedLayer === 'eredmenyek' && evkTelepulesek"-->
<!--          title="A megyei közgyűlésre leadott szavazatok"-->
<!--          :data="evkTelepulesek"-->
<!--      />-->
    </div>
    <!-- megye -->
    <div v-if="!isTelepules && (isMegye || isFovaros)" class="ov2024-list__result__container">
      <span v-if="selectedLayer === 'eredmenyek'">
      <ov-part-bar
        v-if="selectedLayer === 'eredmenyek' && evkTelepulesek"
        :title="isFovaros ? 'Fővárosi közgyűlés összetétele' : 'A megyei közgyűlésre leadott szavazatok'"
        :data="data?.properties?.listak?.filter(l => l.mandatumokSzama > 0)"
      />
      </span>
      <accordion :open="false" class="accordion">
        <template #title>
          <span class="ov2024-list__subtitle">
            {{ isFovaros ? 'Kerületek' : 'Egyéni választókerülettel rendelkező települések' }}
          </span>
        </template>
        <template #content>
          <span class="ov2024-list__highlight">
            <span v-for="t in evkTelepulesek" :key="t.slug" class="ov2024-list__highlight__item">
              <span @click="setTelepules(t)">
                {{ t.nev }}
              </span>
            </span>
          </span>
        </template>
      </accordion>
    </div>
    <!-- orszag -->
    <div v-else-if="!selectedTelepules">
<!--      <span v-if="selectedLayer === 'eredmenyek' && adatVerzio.feldolgozottsag">-->
<!--          <span class="dashboard-24__progress">-->
<!--              <span class="dashboard-24__progress__line">-->
<!--                  Feldolgozottság:-->
<!--                  <span-->
<!--                      class="dashboard-24__progress__data"-->
<!--                      :class="'dashboard-24__progress__data__color__2024o'"-->
<!--                      :style="{ width: (adatVerzio.feldolgozottsag) + '%'}"-->
<!--                  >-->
<!--                      {{ adatVerzio.feldolgozottsag }}%-->
<!--                  </span>-->
<!--              </span>-->
<!--          </span>-->
<!--      </span>-->
      <span class="ov2024-list__result__container orszag">
        <accordion :open="false" class="accordion">
          <template #title>
            <span class="ov2024-list__subtitle">Kiemelt települések</span>
          </template>
          <template #content>
            <ul class="ov2024-list__highlight">
              <li v-for="city in topCities" :key="city.name" style="cursor: pointer" class="ov2024-list__highlight__item" @click="setTelepules(city)">
                <span>
                  {{ city.nev }}
                </span>
              </li>
            </ul>
          </template>
        </accordion>
        <accordion :open="false" class="accordion">
          <template #title>
            <span class="ov2024-list__subtitle">Vármegyék</span>
          </template>
          <template #content>
            <ul class="ov2024-list__highlight">
              <li v-for="m in megyek" :key="m.slug" class="ov2024-list__highlight__item">
                <span @click="setTelepules(m)">
                  {{ m.nev }}{{ !m.isFovaros ? ' vármegye' : '' }}
                </span>
              </li>
            </ul>
          </template>
        </accordion>
      </span>
    </div>
  </div>
</template>
<script>
import { config } from '@/config'
import electionApi from '@/api/ElectionApi'
import Accordion from './Accordion'
import OvPartBar from './OvPartBar'
import partyColor from '@/mixins/partyColor'
import OvParticipationBar from './OvParticipationBar.vue'

export default {
  name: 'OvListResult',
  mixins: [
      partyColor,
  ],
  components: {
    OvParticipationBar,
    Accordion,
    OvPartBar,
  },
  props: {
    basePath: {
      type: String,
      required: true,
    },
    isMapBig: {
      type: Boolean,
      default: false,
    },
    szavazokor: {
      type: Object,
      default: null,
    },
    slug: {
      type: String,
      default: null,
    },
    selectedLayer: {
      type: String,
      default: 'jeloltek',
    },
    data: {
      type: Object,
      default: null,
    },
    adatVerzio: null,
    selectedTimestamp: null,
  },
  data() {
    return {
      topCities: config.topCities,
      defaultJeloltImage: 'data:image/svg+xml;base64,PHN2ZwogICAgICAgICAgICAgICAgICAgIHYtZWxzZQogICAgICAgICAgICAgICAgICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgICAgICAgICAgICAgICAgICB3aWR0aD0iMTAwJSIKICAgICAgICAgICAgICAgICAgICBoZWlnaHQ9IjEwMCUiCiAgICAgICAgICAgICAgICAgICAgdmlld0JveD0iMCAwIDE1MCAxNTAiCiAgICAgICAgICAgICAgICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgICAgICAgICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgICAgICAgICAgICAgICAgICAgc3Ryb2tlLW1pdGVybGltaXQ9IjIiCiAgICAgICAgICAgICAgICAgICAgY2xhc3M9ImFjY29yZGlvbl9fY29udGVudC0tZXBsaXN0X19pbWciCiAgICAgICAgICAgICAgICAgID4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNLS4wMDEuMDAyaDE1MHYxNTBoLTE1MHoiIGZpbGw9IiNmZmYiIC8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTUwLjc1MyAxNTAuMDA0bC4yNTQtNjAuNDQzIDE2Ljk3Ni03Ljc0OWM0LjI1MyA5LjIyIDcuODQyIDE1Ljg0OSAxMi4zNDIgMTkuMzA5IDAgMCAxLjY5LTIuNDUxIDMuMDQ3LTMuMzkyIDUuOTI4LTQuMTE1IDIxLjg0MS0xNS40NjcgMjEuODQxLTE4Ljc3OCAyLjEzNC45NjUgNS43MzMgMy43MDYgMTAuNDI3IDEwLjcxOWwtMTMuMzk2IDYwLjMzM0g1MC43NTN6IiBmaWxsPSIjZmZmIiAvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik03OS43MTkgMTAyLjI0NnMtMTQuMTY0LTE2Ljk4NS0xMi41OC0yMC4yOTdjMCAwLTQuMTU2LTMuMTUzLTUuMjk5LTUuMTg3LTEuODIyLTMuMjQyLTQuNDkzLTguODIzLTQuNjkxLTE0LjI0NS0uMjk3LTguMDktLjQ3NS0yMS41MjYgMy4yOTctMzMuMDM5IDIuMTMtOS44MzMgNi42MDYtMTcuMjU0IDE2LjQ3My0xOS4xMzMgMjIuNzg3LTMuMzM2IDM5LjMzMS43MzcgMzYuMzYxIDMyLjM5NCAwIDAgNy45NyAzLjc5Ni4zNTEgMTcuMzE5LS44NjYgNC45NzktMy43ODIgMTAuMTM0LTcuNTEyIDExLjk3bC0uOTE0IDcuNzI2Yy01LjE1NCA3Ljc1OC0xMy45MTQgMTcuNDEyLTI1LjQ4NyAyMi40OTF6IiBmaWxsPSIjZGRkIiAvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik02Mi42MTcgMTUwLjAwNEg3LjcybC4wNDUtLjU4NWMuNTUzLTcuNDY5IDcuOTIzLTI4Ljk0MyAxMS44MTQtMzcuMjE1Ljg5Ni0xLjkwNSA0LjcyOS05LjI5NSA5Ljc2OS0xMS4zMDUgMTAuNjQ5LTQuMjQ4IDIwLjM1MS0xMC4wMDUgMjAuMzUxLTEwLjAwNS0uMjk3LS43MjcgMi4wOTYtMi41NDYgMi45MjUtMy4yMDQgMi43MTUtMi4xNTcgNy41NjMtMy45OTUgMTAuMTc2LTQuOTg5IDEuMi0uNDU2IDMuNTY3LS43MzggMy44MzgtLjQ0NyAwIDAtMTAuMzQ5IDUuOTI5LTEwLjk3MSA4LjQ4OWwuOTkyIDExLjcxOCA1Ljk1OSA0Ny41NDN6bTM0LjE0MSAwYzEuODU3LTUuNzYgMy43OTQtMTIuMiA1LjY5Ny0xOS4zNTUgMi4wMjQtNy42MTQgMTAuMjc2LTM0LjQyMiAxMS45MDQtNDAuNzQ2LTEuNzMzLTMuNzEzLTMuMTYzLTUuNjM0LTQuNTY2LTcuMDMxLTEuNDQyLTEuNDM1LTIuODUxLTIuMzE0LTQuMTMyLTMuNzM2IDAgMCAxLjExNS4wMTUgMi4yNzguNjgzIDMuNDM4IDEuOTc3IDExLjEyNSA1LjY2NCAxMS4xNjUgOS4yMmwyNi40NTggMTEuODczYy42NDEuMjgzIDIuNDA2IDMuMDQzIDQuNDM4IDYuODk4djQyLjE5NEg5Ni43NTd6bS04LjcyNi00My43MTRjLS4yMjMuNTU4LTEuNDM2IDMuNDI4LTMuMzI2IDQuODFsLjcyNyAzOC45MDRINzMuNDU4bDQuNTk0LTM5LjExNWMtMS43MzctMS43NTQtMy4wMzItNC40NTgtMy4wMzItNC40NThzNC43MTktNC41MzEgNS41OTctNC4wMDVjLjgzLjQ5NiA2Ljg4MiA0LjQwNCA3LjQxNSAzLjg2M3ptMCAwbC4wMzctLjA5NWMtLjAwMS4wNDEtLjAxNC4wNzItLjAzNy4wOTV6TTU5Ljc0IDMzLjkzYy0xLjY3OSA3LjMyNy0yLjIzNyAxNC4yNzUtMi42NTUgMjEuMTc1IDAgMC05Ljg1NS0xMy40Ny00Ljk5MS0yNC44NzktNS44MzMtMy40NjMtOC45MDctNy4xMjItNi45MTEtOC42MDQgMzEuMTk4LTIzLjE2NCA2MS42OS0xOC4wMDggNjMuMDExLTguMTU1IDEzLjI3OCAxLjI3NiA3Ljc4IDMyLjM1NyA3Ljc4IDMyLjM1N3MtMS44Ni0yLjQwOC00LjE1NS0xLjk4NS00LjU1MyAxLjUzOC00LjU1MyAxLjUzOGMxLjIzNi01LjUyLTEuMjkzLTIwLjI0OC0xLjI5My0yMC4yNDhDOTMuNTI3IDQxLjE0MiA3My41MTUgMzkuMzM2IDU5Ljc0IDMzLjkzem00OC4xODEgMzEuMTM0Yy0uMTIzLjk2MyA2LjMxMS02LjQyOSA2LjMxMS02LjQyOS4wODIgNy4yNzUtOC4wNjkgMTMuNjYzLTguMDY5IDEzLjY2M2wxLjc1OC03LjIzNHoiIGZpbGw9IiM5OTkiIC8+CiAgICAgICAgICAgICAgICAgIDwvc3ZnPg==',
      telepulesek: [],
      selectedTelepules: null,
      jelenlegiPolgarmester: null,
      polgarmesterJeloltek: [],
      evkTelepulesek: [],
      szavazokorData: null,
      windowWidth: null,
      megyek: config.counties,
    }
  },
  computed: {
    getTelepulesNev() {
      return this.selectedTelepules
        ? this.selectedTelepules.nev + (this.selectedTelepules.isMegye && !this.selectedTelepules.isFovaros ? ' vármegye' : '')
        : 'Magyarország'
    },
    isFovaros() {
      return this.selectedTelepules && this.selectedTelepules.isFovaros
    },
    isMegye() {
      return this.selectedTelepules && this.selectedTelepules.isMegye
    },
    isTelepules() {
      return this.selectedTelepules && this.selectedTelepules.isVaros
    },
  },
  watch: {
    slug: function(slug) {
      this.setJeloltek(slug)
    },
    szavazokor: function(szavazokor) {
      this.loadSzavazokor(szavazokor)
    },
  },
  mounted() {
    this.setJeloltek(this.$props.slug)
  },
  methods: {
    navigateUp() {
      this.$emit('slug-change', this.$props.slug.split('/').slice(0, -1).join('/'))
      return false;
    },
    setTelepules(item) {
      this.$emit('slug-change', item.slug || '')
    },
    async setJeloltek(slug) {
      const [mSlug, tSlug] = slug ? slug.replace(/^\/|\/$/g, '').split('/').slice(-2) : []
      const evk = this.selectedLayer === 'eredmenyek' ? '' : '-'
      const result = await (await electionApi.getEvkJeloltek(mSlug || '-1', tSlug, evk, (!tSlug ? true : undefined))).json()
      const data = result && result.data && result.data.onk_valasztas && result.data.onk_valasztas.teruletek[0]
      if (data) {
        const item = {
          nev: data.keruletek.length === 1 ? data.keruletek[0].nev : data.nev,
          megyeNev: data.keruletek.length === 1 ? data.nev : '',
          isMegye: data.keruletek.length !== 1,
          isFovaros: data.nev === 'Budapest' && data.keruletek.length !== 1,
          isVaros: data.keruletek.length === 1,
          taz: data.keruletek[0] && data.keruletek[0].taz,
          maz: data.maz,
        }
        item.polgarmesterFeldolgozottsag = item.isFovaros ? data?.polgarmesterFeldolgozottsag : data.keruletek[0].polgarmesterFeldolgozottsag
        const [jelenlegiPolgarmester, polgarmesterJeloltek] = item.isFovaros
          ? [data.jelenlegiPolgarmester, data.polgarmesterJeloltek]
          : [data.keruletek[0] ? data.keruletek[0].jelenlegiPolgarmester : {}, data.keruletek[0] ? data.keruletek[0].polgarmesterJeloltek : []]
        this.jelenlegiPolgarmester = jelenlegiPolgarmester
        this.polgarmesterJeloltek = (this.selectedLayer === 'eredmenyek')
            ? polgarmesterJeloltek.sort((a, b) => parseInt(b.szavazat) - parseInt(a.szavazat))
            : polgarmesterJeloltek
        this.polgarmesterJeloltek = this.polgarmesterJeloltek.filter(j => j.nev)
        let egyezoJelolt = this.polgarmesterJeloltek.find(_ => _.nev === jelenlegiPolgarmester.nev)
        if (!egyezoJelolt) {
          egyezoJelolt = this.polgarmesterJeloltek.find(_ => _.nev === jelenlegiPolgarmester.nev.split(' ').slice(0, -1).join(' '))
        }
        if (this.jelenlegiPolgarmester) {
          this.jelenlegiPolgarmester.fenykep = egyezoJelolt ? egyezoJelolt.fenykep : null
        }
        this.evkTelepulesek = data.keruletek.filter(k => (k.hasEvk)).map(t => ({ ...t, slug: mSlug + '/' + t.slug }))
        this.selectedTelepules = item
      } else {
        this.jelenlegiPolgarmester = null
        this.polgarmesterJeloltek = []
        this.evkTelepulesek = []
        this.selectedTelepules = null
      }
    },
    getParentSlug() {
      const _path = this.$router.currentRoute.path
      const _p = ('/' + (_path.replace(this.basePath, '')
          .replace(/^\/|\/$/g, ''))).split('/').slice(-2)
      return ('/' + (this.$router.currentRoute.path.replace(this.basePath, '')
          .replace(/^\/|\/$/g, '')))
          .split('/').slice(-2)[0] || ''
    },
    async loadSzavazokor(_szavazokor) {
      if (_szavazokor && this.selectedTelepules) {
        _szavazokor.data = {}
        for (const sorszam of _szavazokor.szavazokorok) {
          const result = await (await electionApi.getSzavazokor(this.selectedTelepules.maz, this.selectedTelepules.taz, sorszam.toString().padStart(3, '0'))).json()
          _szavazokor.data['s' + sorszam] = { ...result.data.szavazokor, sorszam }
          if (_szavazokor.data['s' + sorszam].polgarmesterJeloltek) {
            const _sum = _szavazokor.data['s' + sorszam].countSzavazokorSzavazat = _szavazokor.data['s' + sorszam].polgarmesterJeloltek.reduce((_sum, p) => _sum + p.szavazokorSzavazat, 0)
            _szavazokor.data['s' + sorszam].polgarmesterJeloltek = _szavazokor.data['s' + sorszam].polgarmesterJeloltek.map(p => ({ ...p, szavazokorSzazalek:  ((p.szavazokorSzavazat / _sum) * 100).toFixed(2) }))
            _szavazokor.data['s' + sorszam].polgarmesterJeloltek.sort((a, b) => (b.szavazokorSzavazat) - parseInt(a.szavazokorSzavazat))
          } else {
            _szavazokor.data['s' + sorszam].polgarmesterJeloltek = []
          }
          _szavazokor.data['s' + sorszam]._reszvetel = _szavazokor.data['s' + sorszam].reszvetel.filter(r => r.idopont === this.selectedTimestamp)[0]
        }
      }
      this.szavazokorData = _szavazokor
    },
  },
}
</script>
